module.exports = __webpack_public_path__ + "static/images/containers/ShopView/images/big/package_m.12134523.png";


//////////////////
// WEBPACK FOOTER
// ./containers/ShopView/images/big/package_m.png
// module id = 990
// module chunks = 16